import React, { useContext } from 'react'
import { CurrentDashboardContext } from '../wrappers/CurrentDashboardContext'
import DateBarComponent from './date/BarComponent'
import LayoutEditorToggle from './LayoutEditorToggle'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import TopBarDropdown from './TopBarDropdown'
import withConfig from '../wrappers/withConfig'
import { UserContext } from '../wrappers/UserContext'
import { hasAccessToAdmin } from '../../utils/user/permissions'
import AdminLink from './landing-page/AdminLink'
import LogoutButton from './user/LogoutButton'
import ManageUsersButton from './user/ManageUsersButton'

export default withConfig(({ config }) => {
    const {
        currentWidgetGroup: { PageName },
        dashboardName,
        pageLoading,
    } = useContext(CurrentDashboardContext)
    const { user, roles } = useContext(UserContext)
    const { IS_PUBLIC, USE_OKTA, DISPLAY_ADMIN } = config

    return (
        <div role="banner" className="topBarWrapper">
            <HelmetProvider>
                <Helmet>
                    <title>
                        {dashboardName} {!IS_PUBLIC ? `Director ` : ''}Dashboard
                    </title>
                </Helmet>
            </HelmetProvider>
            <div className="widgetGroupNameWrapper">
                <div className="widgetGroupName">
                    <h1 className="dashboardName">{dashboardName} </h1>
                    {!pageLoading && <h2 className="pageName">- {PageName}</h2>}
                    <div className="mobileName">
                        <TopBarDropdown name={PageName} />
                    </div>
                </div>
                <div className="topBarControls">
                    <LayoutEditorToggle />
                    <DateBarComponent />
                    {user && (
                        <div className="userControls">
                            {DISPLAY_ADMIN && hasAccessToAdmin(roles) ? <AdminLink /> : null}
                            {!USE_OKTA && hasAccessToAdmin(roles) ? <ManageUsersButton /> : null}
                            <LogoutButton />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
})
